export default {
    evaluators: undefined,
    evaluatorOptions: [],
    importOptions: [],
    loading: false,
    error: null,
    errorShow: false
}